import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { PanelSection, CheckList } from './DetailPanel';

import imgPowerPlatform from '../assets/img/image-pp.png';
import imgAzure from '../assets/img/Microsoft_Azure.png';
import imgDynamics from '../assets/img/image-dm.png';

// Deep-dive content for the Dynamics 365 & Power Platform practice.
// Rendered inside a DetailPanel drawer.
export default function PowerPlatform() {
  const { t } = useTranslation();

  const highlights = [
    { image: imgAzure, title: t('power.hl1Title'), description: t('power.hl1Desc') },
    { image: imgDynamics, title: t('power.hl2Title'), description: t('power.hl2Desc') },
    { image: imgPowerPlatform, title: t('power.hl3Title'), description: t('power.hl3Desc') },
  ];

  return (
    <Box>
      <Typography variant="body1" color="text.secondary">
        {t('power.subtitle')}
      </Typography>

      <PanelSection title={t('power.coreTitle')}>
        <CheckList
          items={[
            t('power.core1'),
            t('power.core2'),
            t('power.core3'),
            t('power.core4'),
            t('power.core5'),
            t('power.core6'),
          ]}
        />
      </PanelSection>

      <PanelSection title={t('power.highlightsTitle')}>
        <Box sx={{ display: 'grid', gap: 2.5, gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' } }}>
          {highlights.map((h) => (
            <Card key={h.title} sx={{ p: 2.5 }}>
              <Box
                sx={{
                  height: 84,
                  mb: 2,
                  borderRadius: 2.5,
                  display: 'grid',
                  placeItems: 'center',
                  bgcolor: 'rgba(255,255,255,0.92)',
                  p: 1.5,
                }}
              >
                <Box
                  component="img"
                  src={h.image}
                  alt=""
                  sx={{ width: '100%', height: '100%', minWidth: 0, minHeight: 0, objectFit: 'contain' }}
                />
              </Box>
              <Typography variant="h6" component="h4" gutterBottom>
                {h.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {h.description}
              </Typography>
            </Card>
          ))}
        </Box>
      </PanelSection>

      <PanelSection title={t('power.commitmentIntro')}>
        <CheckList items={[t('power.commit1'), t('power.commit2'), t('power.commit3')]} />
      </PanelSection>
    </Box>
  );
}
